import React from "react";
import { Fade } from "react-reveal";
import SubHeader from "../components/SubHeader";
import "./About.css";

export default function About() {
  return (
    <>
      <section className="about" id="about">
        <div className="container">
          <Fade left>
            <div className="about-context col-lg-8">
              <SubHeader
                title={"About Wellingtonia International School"}
                subheader={"Fostering Excellence Beyond the Classroom"}
              />
              <p>
                Wellingtonia International School is transforming education for
                modern students. Using the renowned{" "}
                <strong>Cambridge Assessment International Education</strong>,
                we blend rigorous academics with talent development, nurturing
                each child's strengths. We prioritize personal growth over rote
                memorization, ensuring all students thrive.
              </p>

              <p>
                Our <strong>virtual-first model</strong> allows students to
                learn from anywhere, with personalized guidance from certified
                teachers. While fully operational online, our{" "}
                <strong>physical campus</strong> is also being prepared and will
                soon offer both virtual and in-person learning.
              </p>

              <p>
                Enroll now in our virtual school to give your child a head
                start, benefiting from our flexible education and securing their
                future, whether online or at our upcoming physical campus.
              </p>

              <a
                className="join-wellingtonia"
                href="https://forms.gle/UE7YqR5ni6XUtzip9"
                rel="noreferrer"
                target={"_blank"}
              >
                Enroll Now
              </a>
            </div>
          </Fade>
          <Fade right>
            <div className="about-img col-lg-4"></div>
          </Fade>
        </div>
      </section>
      <hr style={{ color: "#000", position: "relative", zIndex: 12343 }} />
    </>
  );
}
